<template>
  <span>
    <slot name="en" v-if="activeLang === 'en'">
    </slot>
    <slot name="jp" v-if="activeLang === 'jp'">
    </slot>
  </span>
</template>

<script>
  export default {
    name: 'Trans',
    props: {},
    computed: {
      activeLang () {
        return this.$root.lang
      }
    }
  }
</script>

<style scoped>

</style>
